import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class GradeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertSerie = this.insertSerie.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertSerie() {
    this.props.history.push("/serie/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}classification/serie/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data,
                    loading: false
                  }),
                  () => {
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/serie/edit/"
                  title="Séries"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "order", denomination: "Ordem" },
                    { name: "abbreviation", denomination: "Abreviação" },
                    { name: "segment_id", denomination: "Segmento" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertSerie}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GradeList);
